import { EULA_INFO } from 'api/admin/types';
import { Risk } from 'api/file/interfaces/get-file-order-insights';

export const HELP_ROUTE = '/help';
export const HELP_SEARCH_ROUTE = `${HELP_ROUTE}/search`;
export const HELP_COLLECTION_SLUG = 'agentnet';
export const HELP_SITE_SETTINGS_ID = '7Cb1Fdl72TOOso0C1lBmMf';
const commonEulatext =
  'By using the serviceName <b>Service</b> the user agrees The serviceName <b>Service</b> is provided under the AgentNet® END USER LICENSE AGREEMENT as a “licensed product.” . The serviceName <b>Service</b> is provided as a service solely for Agents of First American Title Insurance Company to assist in fraud prevention as a supplemental identity verification tool. First American Title Insurance Company disclaims all liability for unauthorized use.  The serviceName <b>Service</b> is supplemental to and does not replace First American Title Insurance Company’s underwriting standards or industry best practices.';

export const EULA_Texts: EULA_INFO = {
  'Contact Validation': commonEulatext,
  'Enhanced Identity Verification': commonEulatext,
};

export const VERIFICATION_TIME_LIMIT_MESSAGE =
  'Before submitting the request, confirm with the party which document they will use for identity verification and their preferred language for receiving the request. Once sent, they will have 30 minutes to complete the identity verification process.';

export const disableIntegrationText: EULA_INFO = {
  FP001:
    'This integration will no longer be available within Order Insights to validate party contact information. Previously validated contact information will also be unavailable. Do you wish to continue?',
  FP002:
    '  This integration will no longer be available within Order Insights to verify party identities. Previously verified results will also be unavailable. Do you wish to continue?',
};

export const offerMessage = {
  admin: 'Enable this feature in your Admin settings.',
  nonAdmin: "Contact your firm's AgentNet Administrator to enable this feature.",
};

export const OFFER_DETAILS_PENDING = {
  ContactValidation: 'Please add a phone number or email address to the party to use Contact Validation',
  EnhancedIdentityVerification: 'Please add a phone number to the party to use Identity Verification',
};

export const RETRY_VERIFICATION_TEXT =
  'The party failed to complete identity verification. You can send the request count more times.';

export const MAX_IDENTITY_CHECK_ATTEMPTS = 3;

export const MAX_ATTEMPTS_VERIFICATION_TEXT =
  'The party failed to complete identity verification within the allowed 3 attempts. For security reasons, no additional verification attempts are permitted.';

export const validationAlertRisk: Risk = {
  category: 1,
  categoryName: 'Party',
  typeName: 'Validation',
  severity: 1,
  severityName: 'Alert',
  title: 'Validation Risk',
  description: 'One or more validation checks triggered a risk alert.',
  type: 1,
};

export const enhancedVerificationPendingRisk: Risk = {
  category: 1,
  categoryName: 'Party',
  typeName: 'EnhancedIdentityVerification',
  severity: 5,
  severityName: 'Pending',
  title: 'Verification in progress',
  description: 'The enhanced identity check is still pending.',
  type: 1,
};

export const enhancedVerificationFailedRisk: Risk = {
  category: 1,
  categoryName: 'Party',
  typeName: 'EnhancedIdentityVerification',
  severity: 4,
  severityName: 'Error',
  title: 'Verification failed',
  description: 'The enhanced identity check failed to complete successfully.',
  type: 1,
};

export const pdfProductEnableMessage =
  'This feature is not available. Contact your firm’s AgentNet Administrator to enable this feature.';

export const identityReportAvailableText =
  'The Identity Verification Report is available for download until <strong>expiryDate</strong>. After this time, you will need to submit a new identity verification request to access the results. We recommend downloading the PDF now to keep a copy for your records.';

export const oldVerificationRequestText =
  'This request is older than 90 days. Due to our retention guidelines, a new identity verification request is required to view the Identity Verification Report. Please notify the party before sending the request. After it&apos;s sent, they must complete identity verification within 30 minutes.';
